import moment from "moment";
import WorkExperienceIcon from "../assets/work_experience_icon.png"
import "../styles/work_experience.css"

const WorkExperienceComponent = ({ workExperience }) => {
    const workFrom = moment(workExperience.work_from).utc().format("MMM YYYY");
    const workTo = workExperience.work_to? moment(workExperience.work_to).utc().format("MMM YYYY") : moment(Date()).utc().format("MMM YYYY");
    const totalWorkPeriodYear = moment(workTo).diff(moment(workFrom), 'years');
    const totalWorkPeriodMonth = moment(workTo).diff(moment(workFrom), 'months');
    const totalWorkPeriod = totalWorkPeriodYear === 0? `${totalWorkPeriodMonth} months`: `${totalWorkPeriodYear} years, ${totalWorkPeriodMonth % 12} months`;

    return (
        <div className="work-container">
            <div className="column work-icon-container">
                <img className="icon" alt="Work Experience" src={ WorkExperienceIcon } />
            </div>
            <div className="column work-details-container">
                <div className="row company">
                    {`${workExperience.work_company}` || "-"}
                </div>
                <div className="row position">
                    {`${workExperience.work_position}` || "-"} 
                </div>
                <div className="row period">
                    Full time  
                </div>
                <div className="row period">
                    {
                    `${workFrom} - ${workTo}` 
                    }
                    <span style={{paddingLeft:"20px"}}>{totalWorkPeriod}</span>
                </div>
                <div className="row period">
                    {`${workExperience.work_position}` || "-"} 
                </div>
                <div className="row work-summary">
                {`${workExperience.work_summary}` || "-"} 
                </div>
            </div>
        </div>
    )
}

export default WorkExperienceComponent;